/**
 * Utilitário para gerenciar limpeza de stores Zustand durante logout
 */
import { useSidebarStore, clearSidebarStorage } from '@/stores/sidebar-store'
import { useUIStore } from '@/stores/ui-store'

/**
 * Reseta todos os stores para o estado inicial
 * Deve ser chamado durante o processo de logout
 */
export function resetAllStores() {
  // Reset do sidebar store
  useSidebarStore.getState().reset()
  
  // Reset do UI store
  useUIStore.getState().reset()
  
  // Limpa dados persistidos do sidebar
  clearSidebarStorage()
}
